<template>
  <div>
    <div class="p-relative header-image pb-5"></div>

    <b-container class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <!-- Tradies -->
            <b-row>
              <b-col cols="12">
                <h4 class="font-weight-bold pt-4 pb-1 align-middle">
                  Company Tradies
                </h4>
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <CompanyTradieList />
                </b-card>
              </b-col>
            </b-row>

            <!-- Tradies ending company association -->
            <b-row>
              <b-col cols="12">
                <h4 class="font-weight-bold pt-4 pb-1 align-middle">
                  Tradies Ending Company Association
                </h4>
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <TradieEndingCompanyAssociationList />
                </b-card>
              </b-col>
            </b-row>

            <!-- Resumes -->
            <b-row>
              <b-col cols="12">
                <h4 class="font-weight-bold pt-4 pb-1 align-middle">
                  Tradie Resumes
                </h4>
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <CompanyResumeList />
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import CompanyTradieList from '@/components/lists/CompanyTradieList'
import CompanyResumeList from '../../components/lists/CompanyResumeList.vue'
import TradieEndingCompanyAssociationList from '@/components/lists/TradieEndingCompanyAssociationList.vue'

export default {
  components: {
    CompanyTradieList,
    CompanyResumeList,
    TradieEndingCompanyAssociationList,
  },
}
</script>
